import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function Login() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user && user.role) navigate(user.role === "admin" ? "/admin" : "/staff", { replace: true });
  }, [user]); // eslint-disable-line

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const u = await login(email, password);
      navigate(u.role === "admin" ? "/admin" : "/staff", { replace: true });
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-[70vh] items-center justify-center bg-stone-950 px-6 py-16">
      <div className="w-full max-w-sm rounded-3xl border border-stone-800 bg-stone-900 p-8 shadow-2xl">
        <img src="/logo.png" alt="Flavors" className="mx-auto h-16 w-16 rounded-full ring-1 ring-amber-500/40" />
        <h1 className="mt-5 text-center font-display text-2xl font-extrabold text-amber-400">Staff & Admin Login</h1>
        <p className="mt-1 text-center text-sm text-stone-400">Flavors Nigerian Restaurant</p>

        <form onSubmit={submit} className="mt-6 space-y-4">
          <div>
            <Label htmlFor="email" className="text-stone-300">Email</Label>
            <Input id="email" data-testid="login-email-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1.5 bg-stone-800 text-stone-100" placeholder="admin@flavorsorlando.com" />
          </div>
          <div>
            <Label htmlFor="password" className="text-stone-300">Password</Label>
            <Input id="password" data-testid="login-password-input" type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1.5 bg-stone-800 text-stone-100" placeholder="••••••••" />
          </div>
          {error && <p data-testid="login-error" className="text-sm text-rose-400">{error}</p>}
          <button
            data-testid="login-submit-button"
            type="submit"
            disabled={loading}
            className="flex w-full items-center justify-center gap-2 rounded-full bg-orange-700 py-3 font-bold text-white transition-colors duration-200 hover:bg-orange-800 disabled:bg-stone-600"
          >
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
